import React, { Fragment, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { NextStepButton } from "../nextStepButton/NextStepButton";
import { getProfilesList } from "../../store/profiles";
import { WizardProfileProtectionCards } from "./WizardProfileProtectionCards";
import { useDataForSingleWizard } from "../../single/useDataForSingleWizard";
import { WizardProfileProtection } from "./WizardProfileProtection";

import "../../wizardLayout.scss";
import "./MultipleWizardProtectionPage.scss";
import { FormattedMessage } from "react-intl";
import { WizardPageTitle } from "../wizardPageTitle/WizardPageTitle";
import { WizardPaths } from "../../../../router/WizardRouter";
import { TabTitle } from "../../../../components";

export const MultipleWizardProtectionPage = () => {
  const navigate = useNavigate();
  const data = useDataForSingleWizard();

  const profiles = useSelector(getProfilesList);
  const [openedProfile, setOpenedProfile] = useState(null);

  if (!data) return null;

  return (
    <div className="wizard-protection">
      {!openedProfile && (
        <Fragment>
          <WizardPageTitle>
            <TabTitle>
              <FormattedMessage id={"protection_setup"} />
            </TabTitle>
          </WizardPageTitle>
          <WizardProfileProtectionCards
            profiles={profiles}
            onClick={(profile) => setOpenedProfile(profile)}
          />
        </Fragment>
      )}
      {openedProfile && (
        <WizardProfileProtection
          profile={openedProfile}
          goBack={() => setOpenedProfile()}
        />
      )}
      {!openedProfile && (
        <NextStepButton
          doNext={() => navigate(WizardPaths.Devices)}
          nextTab={"assign_devices"}
        />
      )}
    </div>
  );
};
